export default "__VITE_ASSET__DN5KV1Qp__"